
import { Question } from '../types';

export const taj101TafkhimTarqiqQuestions: Question[] = [
  {
    id: 'taj051',
    text: 'What is tafkhīm in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'To make a letter sound thick or full', isCorrect: true },
      { id: 'b', text: 'To make a letter sound thin or empty', isCorrect: false },
      { id: 'c', text: 'To elongate a letter', isCorrect: false },
      { id: 'd', text: 'To shorten a letter', isCorrect: false }
    ],
    explanation: 'Tafkhīm literally means to make something fat or full. In Tajweed, it refers to pronouncing a letter with a full-mouth sound.',
    topic: 'taj101'
  },
  {
    id: 'taj052',
    text: 'What is tarqīq in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'To make a letter sound thin or empty', isCorrect: true },
      { id: 'b', text: 'To make a letter sound thick or full', isCorrect: false },
      { id: 'c', text: 'To elongate a letter', isCorrect: false },
      { id: 'd', text: 'To shorten a letter', isCorrect: false }
    ],
    explanation: 'Tarqīq means to make something thin. In Tajweed, it refers to pronouncing a letter with an empty-mouth or thin sound.',
    topic: 'taj101'
  },
  {
    id: 'taj053',
    text: 'How many categories are there for the letters of the Arabic alphabet concerning tafkhīm and tarqīq?',
    type: 'single',
    options: [
      { id: 'a', text: 'Three categories', isCorrect: true },
      { id: 'b', text: 'Two categories', isCorrect: false },
      { id: 'c', text: 'Four categories', isCorrect: false },
      { id: 'd', text: 'Five categories', isCorrect: false }
    ],
    explanation: 'The letters of the Arabic alphabet can be divided into three categories regarding tafkhīm and tarqīq: those which are always read with tafkhīm, those which are always read with tarqīq, and those which are sometimes read with tafkhīm and sometimes with tarqīq.',
    topic: 'taj101'
  },
  {
    id: 'taj054',
    text: 'Which letters are always read with tafkhīm (full-mouth)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The letters of istiʿlāʾ (خُصَّ ضَغْطٍ قِظْ)', isCorrect: true },
      { id: 'b', text: 'The letters of hams (فَحَثَّهُ شَخْصٌ سَكَتْ)', isCorrect: false },
      { id: 'c', text: 'The letters of qalqalah (قُطْبُ جَدٍّ)', isCorrect: false },
      { id: 'd', text: 'The letters of shiddah (أَجِدْ قَطٍ بَكَتْ)', isCorrect: false }
    ],
    explanation: 'The letters which are always read with tafkhīm (full-mouth) are all the letters which have the ṣifah of istiʿlāʾ, found in the combination خُصَّ ضَغْطٍ قِظْ.',
    topic: 'taj101'
  },
  {
    id: 'taj055',
    text: 'Which letters can sometimes be read with tafkhīm and sometimes with tarqīq?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'The alif (ا)', isCorrect: true },
      { id: 'b', text: 'The lām (ل) in the word Allah', isCorrect: true },
      { id: 'c', text: 'The rāʾ (ر)', isCorrect: true },
      { id: 'd', text: 'The nūn (ن)', isCorrect: false }
    ],
    explanation: 'The letters which are sometimes read with tafkhīm and sometimes with tarqīq are: the alif (ا), the lām (ل) in the word Allah, and the rāʾ (ر).',
    topic: 'taj101'
  },
  {
    id: 'taj056',
    text: 'What determines whether an alif is read with tafkhīm or tarqīq?',
    type: 'single',
    options: [
      { id: 'a', text: 'The letter before it', isCorrect: true },
      { id: 'b', text: 'The letter after it', isCorrect: false },
      { id: 'c', text: 'Its position in the word', isCorrect: false },
      { id: 'd', text: 'The vowel on the alif itself', isCorrect: false }
    ],
    explanation: 'The alif does not have the quality of tafkhīm or tarqīq itself but is dependent on the letter before it. If the alif is preceded by a full-mouth letter, it will be read with a full mouth, and if preceded by an empty-mouth letter, it will be read with an empty mouth.',
    topic: 'taj101'
  },
  {
    id: 'taj057',
    text: 'When is the lām in the word Allah read with tafkhīm?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When preceded by a fatḥah', isCorrect: true },
      { id: 'b', text: 'When preceded by a ḍammah', isCorrect: true },
      { id: 'c', text: 'When preceded by a kasrah', isCorrect: false },
      { id: 'd', text: 'When preceded by a sukūn', isCorrect: false }
    ],
    explanation: 'If the lām in the name Allah is preceded by a fatḥah or ḍammah, it will be read with tafkhīm. If preceded by a kasrah, it will be read with tarqīq.',
    topic: 'taj101'
  },
  {
    id: 'taj058',
    text: 'What are the conditions for rāʾ mutaḥarrikah (rāʾ with a vowel) to be read with tafkhīm?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When it has a fatḥah', isCorrect: true },
      { id: 'b', text: 'When it has a ḍammah', isCorrect: true },
      { id: 'c', text: 'When it has a kasrah', isCorrect: false },
      { id: 'd', text: 'When it has a sukūn', isCorrect: false }
    ],
    explanation: 'If the rāʾ has a fatḥah or a ḍammah, it will be read with tafkhīm. If it has a kasrah, it will be read with tarqīq.',
    topic: 'taj101'
  },
  {
    id: 'taj059',
    text: 'When is rāʾ sākinah (rāʾ with sukūn) read with tarqīq?',
    type: 'single',
    options: [
      { id: 'a', text: 'When preceded by a kasrah', isCorrect: true },
      { id: 'b', text: 'When preceded by a fatḥah', isCorrect: false },
      { id: 'c', text: 'When preceded by a ḍammah', isCorrect: false },
      { id: 'd', text: 'When it appears at the end of a word', isCorrect: false }
    ],
    explanation: 'If the rāʾ sākinah is preceded by a kasrah, it will be read with tarqīq. If preceded by a fatḥah or ḍammah, it will be read with tafkhīm.',
    topic: 'taj101'
  },
  {
    id: 'taj060',
    text: 'What is an exception to the rule that rāʾ sākinah preceded by a kasrah is read with tarqīq?',
    type: 'single',
    options: [
      { id: 'a', text: 'If it\'s followed by a letter of istiʿlāʾ in the same word', isCorrect: true },
      { id: 'b', text: 'If it appears at the beginning of a word', isCorrect: false },
      { id: 'c', text: 'If it appears after a long vowel', isCorrect: false },
      { id: 'd', text: 'If it appears before a mushaddad letter', isCorrect: false }
    ],
    explanation: 'An exception to the rule that rāʾ sākinah preceded by a kasrah is read with tarqīq occurs if the rāʾ sākinah is followed by a letter of istiʿlāʾ in the same word, such as in فِرْقَة or مِرْصَاد. In these cases, contrary to the rule, the rāʾ will be pronounced with tafkhīm.',
    topic: 'taj101'
  }
];
